export default "__VITE_ASSET__90e8aef5__"